import React from "react";

import promocionAlarma1 from "../assets/img/HouseDesk.png";
//import promocionAlarma1Mobile from "../assets/img/promoMobile.jpg";
import promocionAlarma1Mobile from "../assets/img/HouseMob.png";

import "../assets/css/bottomImgPanel.css";

export const BottomImgPanel = () => {
  //const text = "Recibe asesoramiento sin cargo"; //??
  const text = "Prosegur Alarmas"; //??

  return (
    <div className="bottom-panel-title">
      <div className="bottom-panel-img">
              <img
                src={promocionAlarma1Mobile}
                alt={text}
                className="img-mobile"
              />
              <img
                src={promocionAlarma1}
                alt={text}
                className="img-desk"
              />
      </div>
    </div>
  );
};
